import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MdPaginator, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IesHttpClient } from '../../Common/ies-http-client.service';
import { Enum } from '../../utility/enum.enum';
import { AppMessage } from './../../Common/appMessage';
import { AppUrl } from './../../Common/appUrl';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { userRole_siteAdmin } from './../../Common/appConstant';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';

@Component({
  selector: 'adm-manage-site-admin',
  templateUrl: './adm-manage-site-admin.component.html',
  styleUrls: ['./adm-manage-site-admin.component.css'],
  providers: [FeatureFlagService],
})
export class AdmManageSiteAdminComponent implements OnInit, OnDestroy {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;

  // used in html to pass url/searchParams to update pagination
  appUrl = AppUrl;
  httpClient: IesHttpClient; // used to make object of md-table
  isSearchDisable: boolean;
  form: FormGroup;
  formControl: any;
  regionFilteredOptions: any;
  locationFilteredOptions: any;
  nameFilteredOptions: any;
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  adminDetailPaginationInfo: any = { totalRecords: 0 }; // Set initial value of Totalrecords property
  displayedColumns = ['firstName', 'email', 'contactNo', 'locationName', 'locationAddress', 'accessLevel', 'status', 'Action'];

  constructor(private featureFlags: FeatureFlagService, private _sharedService: SharedService, public _utility: Utility, public _appMessage: AppMessage, httpClient: IesHttpClient, public _appGlobal: AppGlobals) {
    this.httpClient = httpClient;
    this.form = new FormGroup(
      {
        searchNameControl: new FormControl(),
        searchRegionControl: new FormControl(),
        searchLocationControl: new FormControl()
      }
    );
    this.formControl = this.form.controls;

  }

  private redirect() {
    window.location.assign("/ies/internal/manage-site-administrators");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_SITE_ADMINISTRATORS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_SITE_ADMINISTRATORS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    // to get data of Site Admin and bind with AutoComplete and Grid
    this._utility.addLoaderCount();
    this._sharedService.getUsers("?userRole=" + userRole_siteAdmin).subscribe(response => {
      this._utility.onSuccessCallback(response, null, function () {
        this.dataSubject.next(response.response.results);
        this.adminDetailPaginationInfo = response.response.paginationInfo; // update paginaton info
      }.bind(this));

    }, error => this._utility.onErrorCallback(error));

    // to get data of all regions and bind with AutoComplete
    if (this._sharedService.regionList) {
      this._utility.setDataInComboField('region', this._sharedService.regionList, this.form.controls.searchRegionControl, this);
    } else {
      this._sharedService.getComboFieldsData(Enum.Region, function (response) {
        this._sharedService.regionList = response.response;
        this._utility.setDataInComboField('region', response.response, this.form.controls.searchRegionControl, this);
      }.bind(this));
    }

    // to get data of all locations and bind with AutoComplete
    if (this._sharedService.locationList) {
      this._utility.setDataInComboField('location', this._sharedService.locationList, this.form.controls.searchLocationControl, this);
    } else {
      this._sharedService.getComboFieldsData(Enum.LocationName, function (response) {
        this._sharedService.locationList = response.response;
        this._utility.setDataInComboField('location', response.response, this.form.controls.searchLocationControl, this);
      }.bind(this));
    }

    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);
    this.readFormControlValueChanges();

    // Load Business center and Location mapped with Business Center (Used in Add & Update form)
    this._sharedService.getComboFieldsData(Enum.BusinessCenter, function (response) {
      this._sharedService.businessCenterList = response.response;
    }.bind(this));

    let params = "?outputType=" + Enum.LocationName + '&inputType=' + Enum.BusinessCenter;
    this._sharedService.requestDataForCombo(params).subscribe((response: any) => {
      this._sharedService.locationMappedWithBCenterList = response.response.results;
    }, error => { });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  //parameter added on the basis of selected form field for search
  onSearchClick() {
    let params = "?userRole=" + userRole_siteAdmin + "&";
    let controls = this.form.controls;
    if (controls.searchNameControl.value)
      params += `searchText=${controls.searchNameControl.value}&`;
    if (controls.searchRegionControl.value && controls.searchRegionControl.value.id)
      params += `regionId=${controls.searchRegionControl.value.id}&`;
    if (controls.searchLocationControl.value && controls.searchLocationControl.value.id)
      params += `locationId=${controls.searchLocationControl.value.id}&`;
    this._utility.addLoaderCount();
    this._sharedService.getUsers(params.substring(0, params.length - 1)).subscribe(response => {
      this._utility.onSuccessCallback(response, null, function () {
        //initialize index of grid pagination after every search
        this.paginator.pageIndex = 0;
        this.dataSource.curPage = 2;
        this.dataSubject.next(response.response.results);
        this.adminDetailPaginationInfo = response.response.paginationInfo; // update paginaton info
      }.bind(this));
    }, error => this._utility.onErrorCallback(error));

  }

  readFormControlValueChanges() {

    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        this.isSearchDisable = this._utility.searchDisable(form, ['searchNameControl'], true);
      });

    this.formControl.searchRegionControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.regionChanges(value);
      });

    this.formControl.searchLocationControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.locationChanges(value);
      });

    this.formControl.searchNameControl.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.nameChanges(value);
      });
  }

  /**
   * Load data in Location dropdown & country droddown
   * TO Load data in location we hit request
   * To Load data in country we simply filter at our end
   * @param value - selected region
   */
  regionChanges(value) {
    if (value && value.id) {
      // Here we have to show locations based on selected region
      let param = "?outputType=" + Enum.LocationName + "&id=" + value.id + "&inputType=" + Enum.Region;
      this._sharedService.requestDataForCombo(param).subscribe(response => {
        this._utility.onSuccessCallback(response, null, () => {
          this._utility.setDataInComboField('location', response.response.results, this.formControl.searchLocationControl, this);
        });
      });
      let data = this._sharedService.locationList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('location', data, this.formControl.searchLocationControl, this);
      }
    } else {
      this._utility.setDataInComboField('location', null, this.formControl.searchLocationControl, this); // we have passed second params is null means we are not passing any custom data from here, so it will load all locations
    }
    this.formControl.searchLocationControl.setValue('');
  }

  /**
   * reset blank list/data in First/Last name autocomplete
   * @param value - selected region
   */
  locationChanges(value) {
    if (value && value.id) {
      // Here we have to show locations based on selected region
    }
    this._utility.setDataInComboField('name', [], this.form.controls.searchNameControl, this);
  }

  /* This function called When we type something on search "Enter First Name or Last Name" field
   Presented with top 10 records matching the entered criteria.
   If there are three later typed then hit request after half seconds of that to get suggestion
   Set all returned data into nameOptions array
  */
  nameChanges(searchInput: string): void {
    let distinctRecord = [];
    if (searchInput && searchInput.length > 2) {
      let params = "?userRole=" + userRole_siteAdmin + "&";
      let controls = this.form.controls;
      if (controls.searchNameControl.value)
        params += "searchText=" + controls.searchNameControl.value + "&";
      if (controls.searchRegionControl.value && controls.searchRegionControl.value.id)
        params += "regionId=" + controls.searchRegionControl.value.id + "&";
      if (controls.searchLocationControl.value && controls.searchLocationControl.value.id)
        params += "locationId=" + controls.searchLocationControl.value.id + "&";

      this._sharedService.getUsers(params.substring(0, params.length - 1))
        .subscribe(
        (response: any) => {
          this._utility.onSuccessCallback(response, null, function () {
            let adminList = response.response.results;
            if (controls.searchNameControl.value && adminList.length > 0) {
              distinctRecord = this._utility.checkDuplicateRecord(adminList);
            }
            this._utility.setDataInComboField('name', distinctRecord, this.form.controls.searchNameControl, this);
          }.bind(this), false);
        },
        error => {
          this._utility.onErrorCallback(error, null, false);
        }
        );
    }
  }

  // Set admin status icons based on its value
  getStatusCls(value) {
    try {
      if (value == 1) return 'activeStatusCls';
      if (value == 3) return 'retireStatusCls';
    }
    catch (Exception) { }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-site-admin/adm-manage-site-admin.component.ts